/* globals NodeList */

const TOOLTIP_COLLECTION_METHODS = ['show', 'hide', 'update', 'dispose']

const myDefaultAllowList = bootstrap.Tooltip.Default.allowList
const defaultOptions = { container: 'body' }

const originalTooltipDispose = bootstrap.Tooltip.prototype.dispose

bootstrap.Tooltip.prototype.dispose = function () {
  if (!this._element) return
  originalTooltipDispose.call(this)
}

// To allow elements
myDefaultAllowList.a = ['target', 'href', 'title', 'rel', 'data-method', 'data-remote', 'data-bs-toggle', 'data-bs-target', 'data-link', 'data-turbo-frame', 'data-turbo']

window.createTooltips = (el, options = {}) => {
  return createPopoverOrTooltipCollection(el, 'Tooltip', { ...defaultOptions, ...options })
}

window.createPopovers = (el, options = {}) => {
  return createPopoverOrTooltipCollection(el, 'Popover', { ...defaultOptions, ...options })
}

window.hideTooltips = (el) => {
  const tooltips = window.createTooltips(el)
  const hideInstance = (instance) => instance?.hide?.()
  tooltips.forEach(hideInstance)
}

export function disposeBootstrapInstances () {
  const bootstrapApi = window.bootstrap
  if (!bootstrapApi) return

  document.querySelectorAll('[data-bs-original-title], [data-bs-toggle="tooltip"]').forEach(el => {
    bootstrapApi.Tooltip?.getInstance?.(el)?.dispose()
  })
  document.querySelectorAll('[data-bs-toggle="popover"]').forEach(el => {
    bootstrapApi.Popover?.getInstance?.(el)?.dispose()
  })
  disposeModals()
}

export function disposeModals (root = document) {
  const bootstrapApi = window.bootstrap
  if (!bootstrapApi) return

  root.querySelectorAll('.modal').forEach(el => {
    const modal = bootstrapApi.Modal?.getInstance?.(el)
    if (!modal) return
    // Reset visible state so Turbo cache doesn't snapshot an open modal
    el.classList.remove('show')
    el.style.display = ''
    el.removeAttribute('aria-modal')
    el.setAttribute('aria-hidden', 'true')
    modal.dispose()
  })

  if (document.querySelector('.modal.show')) return

  document.querySelectorAll('.modal-backdrop').forEach(el => el.remove())
  document.body?.classList.remove('modal-open')
  document.body?.style?.removeProperty('overflow')
  document.body?.style?.removeProperty('padding-right')
}

window.disposeBootstrapInstances = disposeBootstrapInstances

function createPopoverOrTooltipCollection (el, type, options = defaultOptions) {
  const isJQueryObject = (input) => window.jQuery && input instanceof window.jQuery
  const isJQueryLike = (input) => input?.jquery && typeof input.toArray === 'function'
  const isDomElement = (input) => input?.nodeType === 1
  const isNodeList = (input) => Object.prototype.isPrototypeOf.call(NodeList.prototype, input)
  const HtmlCollectionCtor = window.HTMLCollection
  const isHtmlCollection = (input) => HtmlCollectionCtor && Object.prototype.isPrototypeOf.call(HtmlCollectionCtor.prototype, input)

  const normalizeElements = (input) => {
    if (!input) return []
    if (isJQueryObject(input) || isJQueryLike(input)) return input.toArray()
    if (isDomElement(input)) return [input]
    if (isNodeList(input) || isHtmlCollection(input) || Array.isArray(input)) return Array.from(input)

    return []
  }

  const instantiate = (element) => {
    try {
      if (!element || typeof element.querySelectorAll !== 'function') return null

      const normalizeOptionElement = (value) => {
        if (!value) return value
        if (window.jQuery && value instanceof window.jQuery) return value[0] || false
        if (value.jquery && value[0] !== undefined) return value[0] || false
        return value
      }

      const normalizedOptions = {
        ...options,
        container: normalizeOptionElement(options.container)
      }

      const oppositeType = type === 'Tooltip' ? 'Popover' : 'Tooltip'
      const oppositeInstance = bootstrap[oppositeType]?.getInstance?.(element)
      if (oppositeInstance) {
        // Bootstrap allows only one overlay type per element.
        // Reuse the bound instance to avoid "more than one instance" runtime errors.
        return oppositeInstance
      }

      return bootstrap[type].getOrCreateInstance(element, {
        ...normalizedOptions,
        placement: element.dataset?.bsPlacement || normalizedOptions.placement || 'auto',
        fallbackPlacements: []
      })
    } catch (error) {
      console.log(error, element)
    }
  }

  const createCollection = (instances) => {
    const collection = instances

    TOOLTIP_COLLECTION_METHODS.forEach((methodName) => {
      collection[methodName] = (...args) => {
        collection.forEach((instance) => instance?.[methodName]?.(...args))
        return collection
      }
    })

    return collection
  }

  const elements = normalizeElements(el)
  const instances = elements.map(element => instantiate(element)).filter(Boolean)
  return createCollection(instances)
}
